<template>
    <div v-if="active" class="tab-content">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { useNuxtApp } from 'nuxt/app'

export default {
    name: 'PilulkaTab',
    props: {
        tabId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        defaultActive: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            active: this.defaultActive,
        }
    },

    created() {
        this.$parent.tabs.push(this)
    },

    methods: {
        select() {
            this.active = true
            if (typeof window !== 'undefined') {
                this.$nextTick(function () {
                    const nuxtApp = useNuxtApp()
                    const lazyload = nuxtApp.$lazyload
                    const media = document.querySelectorAll('.lazyload') as unknown as HTMLElement[]
                    media.forEach((m) => lazyload(m))
                })
            }
        },
        unselect() {
            this.active = false
        },
    },
}
</script>
